export const NESTED_PLATFORM_OPTIONS = {
    '2-2': 'IG Stories',
    '2-1': 'IG Feed',
    '2-5': 'IG Reels',
};

export enum FILTER_ORIGIN {
    HOME = 'Home',
    INSIGHTS = 'Insights',
    SMP = 'Social',
    BROADCAST_EXPOSURES = 'Broadcast Exposure',
    SETTINGS = 'Settings',
    AUTO_INSIGHTS = 'Auto Insights',
}
